import review1 from "./reviews/cedric.js";
import review2 from "./reviews/eris.js";
import review3 from "./reviews/cayune.js";
import review4 from "./reviews/kevin.js";
import review5 from "./reviews/andy.js";

window.reviews = [review1, review2, review3, review4, review5];
